import { render, staticRenderFns } from "./NotReceivedCampaignCard.vue?vue&type=template&id=0523a46a&scoped=true"
import script from "./NotReceivedCampaignCard.vue?vue&type=script&lang=js"
export * from "./NotReceivedCampaignCard.vue?vue&type=script&lang=js"
import style0 from "./NotReceivedCampaignCard.vue?vue&type=style&index=0&id=0523a46a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0523a46a",
  null
  
)

export default component.exports